export default function openInBrowser(url: string): void {
  window.open(url)
}
